var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrap"},[_c('assets-approvel',{attrs:{"departmentId":_vm.departmentId,"isApprovelType":_vm.isApprovelType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }